import CommentModal from './comment-modal';

export default CommentModal;